export default "__VITE_ASSET__BT9GsFcR__"